import createModel, { prop } from 'models/lib/create_model';

export const QuickReplyOption = createModel({
  modelName: 'QuickReplyOption',

  properties: {
    id: prop(String).isRequired,
    label: prop(String).isRequired,
  },
});
